let HttpStatusCode = {
    NoContent: 204
}

export async function handleResponse(response: Response) {
    if (!response.ok && !response.redirected) throw new Error(await getResponseErrorMessage(response));
    if (response.status === HttpStatusCode.NoContent) return;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.startsWith("application/json")) {
        return response.json()
    }
}

export async function getResponseErrorMessage(response: Response) {
    let data = null;
    let text = null;
    try {
        text = await response.text();
        data = JSON.parse(text);
    } catch {
        data = text;
    }
    let message = data;
    if (data) {
        if (data.message) {
            message = data.message;
        }
        else if (data.Message) {
            message = data.Message;
        }
        else if (data.error) {
            message = data.error;
        }
        else if (data.Error) {
            message = data.Error;
        }
    }
    if (response.status === 500 || response.status < 0) {
        message = "An unexpected error occurred. Please try again.";
    }
    if (response.status === 504) {
        message = "Your request timed out before results were returned. You may need to try the operation again.";
    }
    if (response.status === 403) {
        message = "Your request is not allowed.";
    }    
    return (typeof message === "string" ? message : "") || "An unexpected error occurred. Please try again.";
}
